export const FORM_FIELD_METADATA_KEY = Symbol('formField');

export const COMMON_CONSTANTS = {

  CANCEL: 'Cancel',
  CONFIRM: 'Confirm'
};
